.List {
  position: relative;
  display: flex;
  min-width: 0;

  /* wonder why this is here */
  /* stylelint-disable-next-line primer/spacing */
  margin-bottom: -1px;
  list-style: none;
  align-items: flex-start;
  gap: var(--actionbar-gap, var(--stack-gap-condensed));
  overflow: hidden;
  /* Explicit height is required to clip wrapped items */
  height: var(--actionbar-height, var(--control-small-size));

  /* Scroll-based animations have no effect unless the container is scrollable (has overflow, even with overflow:hidden)
  so we can use them to detect overflow. It would be cleaner to use scroll-state container queries for this, but
  browser support for scroll-driven animations is slightly better. */
  animation: detect-overflow linear;
  animation-timeline: scroll(self block);

  /* Isolate the frequent overflow-driven reflows (JS visibility toggling + item wrapping) so they
  can't invalidate ancestor layout. Safe because the list already clips (overflow: hidden) and the
  More menu is portaled, so it isn't affected by the new containing block/stacking context. */
  contain: layout;

  /* After initial render, JS is used to control visibility which provides progressive enhancement for unsupported browsers */
  &[data-has-overflow='true'] {
    --morebutton-display: flex;
  }

  &:where([data-size='small']) {
    --actionbar-height: var(--control-small-size);
  }

  &:where([data-size='medium']) {
    --actionbar-height: var(--control-medium-size);
  }

  &:where([data-size='large']) {
    --actionbar-height: var(--control-large-size);
  }

  /* Gap scale (mirrors Stack) */
  &:where([data-gap='none']) {
    --actionbar-gap: 0;

    .Divider {
      padding: 0 var(--base-size-8);
    }
  }

  &:where([data-gap='condensed']) {
    --actionbar-gap: var(--stack-gap-condensed);
  }

  & [data-overflowing] {
    /* Hide overflowing items. Even though they are clipped by `overflow: hidden`, setting `visibility: hidden` ensures
    they can't accidentally be shown and also hides them from screen readers / keyboard nav. `!important` prevents
    consumers from unintentionally overriding this and breaking accessibility. */
    visibility: hidden !important;
  }
}

@keyframes detect-overflow {
  0%,
  100% {
    --morebutton-display: flex;
  }
}

.Nav {
  display: flex;
  padding-inline: var(--base-size-16);
  justify-content: flex-end;
  align-items: center;

  &:where([data-flush='true']) {
    padding-inline: 0;
  }
}

.Divider {
  &::before {
    display: block;
    width: var(--borderWidth-thin);
    height: var(--base-size-20);
    content: '';
    /* stylelint-disable-next-line primer/colors */
    background: var(--borderColor-muted);
    /* stylelint-disable-next-line primer/spacing */
    margin-top: calc((var(--actionbar-height) - var(--base-size-20)) / 2);
  }
}

.Group {
  display: flex;
  gap: inherit;
}

.OverflowContainer {
  display: flex;
  flex-wrap: wrap;
  gap: inherit;
  justify-content: flex-end;
  overflow: hidden;

  /* Contain the wrap/measure reflows to this subtree. */
  contain: layout;

  .OverflowSpacer {
    height: var(--actionbar-height);
  }
}

.MoreButton {
  display: var(--morebutton-display, none);
}
